import { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePricing } from '../../hooks/usePricing';
import { useMarketingMetadata } from '../../hooks/useMarketingMetadata';
import { MarketingFaq } from '../../components/marketing/MarketingFaq';
import './pricing-page.css';

const features = [
  'Ventas, mesas e inventario desde tu TPV',
  'Aplicación para PDA y pantalla de cocina',
  'VeriFactu incluido: configura tus datos fiscales para empezar',
  'Cierres e informes sincronizados en la nube',
  'Gestión de tus locales desde una misma cuenta',
  'Actualizaciones y corrección de errores de Hosty',
];

export function PricingPage() {
  const pricing = usePricing();
  const [quantity, setQuantity] = useState(1);
  useMarketingMetadata('Precio del TPV para hostelería | TPV Hosty', 'Un plan por TPV principal con todos los módulos e IVA incluido. Consulta qué incluye Hosty, calcula tu cuota y revisa los servicios opcionales.');
  return (
    <>
    <section className="section hosty-pricing">
      <div className="container">
        <div className="section__header text-center" style={{ marginInline: 'auto' }}>
          <span className="marketing-eyebrow">Un plan para todo tu equipo</span>
          <h1>Todo el software.<br />Una cuota por TPV.</h1>
          <p className="muted">Una cuota por TPV principal, con IVA incluido. Sin comprar módulos adicionales.</p>
        </div>
        <article className="pricing-card pricing-card--featured hosty-pricing__plan">
          <div className="hosty-pricing__offer">
            <h2>Hosty completo</h2>
            <div className="pricing-card__price">
              <span className="pricing-card__price-amount">{pricing.amount} €</span>
              <span className="pricing-card__price-period">/mes por TPV principal<br />IVA incluido</span>
            </div>
            <p>El software para atender mesas, coordinar la cocina y controlar tu negocio.</p>
            <p className="hosty-pricing__terms">Equipos, instalación y soporte técnico aparte. Pagos integrados opcionales, con tarifa por operación.</p>
            <Link to="/registro" className="ui-btn ui-btn--primary ui-btn--lg">Crear cuenta y contratar</Link>
            <Link to="/login?demo=1" className="hosty-pricing__demo">Ver demo del panel</Link>
          </div>
          <ul className="pricing-card__features">
            {features.map((feature) => (
              <li key={feature}>
                <svg className="pricing-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                {feature}
              </li>
            ))}
          </ul>
          <div className="hosty-pricing__quantity">
            <label htmlFor="pricing-quantity">¿Varios TPV principales?</label>
            <select id="pricing-quantity" className="ui-input" value={quantity} onChange={(event) => setQuantity(Number(event.target.value))}>
              {[1, 2, 3, 4, 5, 10].map((n) => <option key={n} value={n}>{n} TPV</option>)}
            </select>
            <output htmlFor="pricing-quantity" aria-live="polite" aria-atomic="true">{quantity * pricing.amount} €/mes <small>IVA incluido</small></output>
            <p className="muted">La misma cuota por cada TPV, estén en un local o en varios. El software de PDA y cocina está incluido.</p>
          </div>
        </article>
        <div className="hosty-pricing__extras">
          <section>
            <h2>Pagos integrados, si los necesitas</h2>
            <p>Puedes seguir con tu datáfono habitual. Los cobros procesados a través de Hosty tienen una tarifa por operación que incluye Stripe y Hosty.</p>
            <p className="muted">Revisa y acepta las condiciones antes de activar el servicio. La comisión la asume el restaurante, sin recargo al comensal.</p>
          </section>
          <section>
            <h2>Ayuda y servicios técnicos</h2>
            <p>Las consultas sobre tu cuenta y facturación, y la corrección de errores de Hosty, no tienen coste.</p>
            <p className="muted">Instalación e intervenciones técnicas con presupuesto aparte. Los equipos físicos no forman parte de la cuota del software.</p>
            <Link to="/contacto">Consultar una instalación</Link>
          </section>
        </div>
      </div>
    </section>
    <MarketingFaq />
    </>
  );
}
